/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingField } from './PropertySharingField';
/**
 * Parameter resolved from one allowlisted property field.
 */
export type PropertySharingFieldPart = {
    /**
     * Discriminator for a persisted property field.
     */
    kind: PropertySharingFieldPart.kind;
    /**
     * Stable field identity.
     */
    field: PropertySharingField;
};
export namespace PropertySharingFieldPart {
    /**
     * Discriminator for a persisted property field.
     */
    export enum kind {
        PROPERTY = 'property',
    }
}

